import { getInfoByService } from "@domain/enums/local/getInfoByService";
import { ServiceMetadataStore } from "@infrastructure/stores/serviceMetadata.store";
import { LoopIcon, HistoryIcon } from "@boundary/components/icons";
import styles from "./searchInput.module.scss";

interface SuggestionItemProps {
  serviceType: string;
  onClick: (type: string) => void;
}

function SuggestionItem({ serviceType, onClick }: SuggestionItemProps) {
  return (
    <li
      onClick={() => onClick(serviceType)}
      className={`${styles.suggestionItem} ${styles.suggestionItemContent}`}
    >
      <span className={styles.historyIconWrapper}>
        <HistoryIcon size={12} />
      </span>
      {getInfoByService(serviceType).title}
    </li>
  );
}

export interface SuggestionsListProps {
  suggestions: string[];
  onSuggestionClick: (type: string) => void;
}

export function SuggestionsList({ suggestions, onSuggestionClick }: SuggestionsListProps) {
  if (!suggestions.length) return null;

  const validSuggestions = suggestions.filter((v) => ServiceMetadataStore.getByType(v));

  if (!validSuggestions.length) return null;

  return (
    <ul className={styles.suggestionsList}>
      {validSuggestions.map((serviceType, index) => (
        <SuggestionItem
          key={`${index}-${serviceType}`}
          serviceType={serviceType}
          onClick={onSuggestionClick}
        />
      ))}
    </ul>
  );
}

export interface SearchInputProps {
  value: string;
  onChange: (value: string) => void;
}

export function SearchInput({ value, onChange }: SearchInputProps) {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <div className={styles.inputWrapper}>
      <span className={styles.searchIcon}>
        <LoopIcon size={18} />
      </span>
      <input
        name="map-service"
        value={value}
        onChange={handleChange}
        className={`${styles.input} ${styles.inputPlaceholder}`}
        placeholder="Найти услугу"
      />
    </div>
  );
}

